module.exports = __webpack_public_path__ + "img/back-0-35d0788e.png";